import React, { Fragment, useState } from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";
import CustomImageUpload from "../../components/Forms/CustomInputs/CustomImageUpload";

const AddUpdateUI = ({ selectedState, setSelectedState, formik }) => {
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;
  const [formatDuration, setFormatDuration] = useState("");
  const removeIndex = (index) => {
    let tmpValues = [...values.format_duration];
    tmpValues.splice(index, 1);
    setFieldValue('format_duration', tmpValues);
  }
  return (
    <Fragment>
      <CustomTextbox
        fieldName="name"
        value={values.name}
        error={errors.name}
        label={"Art Form Name"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      <CustomImageUpload
        fieldName="icon"
        value={values.icon}
        error={errors.icon}
        label={"Icon for Art Form (SVG ONLY)"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        mediaType="svg"
        imageRatio="1_1"
      />

      <div className="row" style={{ marginBottom: '15px' }}>
        <div className="col-6" style={{ paddingRight: '10px' }}>
          <CustomTextbox
            fieldName="base_color"
            value={values.base_color}
            error={errors.base_color}
            label={"Base Color"}
            classes={"col-12"}
            handleBlur={handleBlur}
            inputType={"color"}
            handleChange={handleChange}
          />
        </div>
        <div className="col-6" style={{ paddingLeft: '10px' }}>
          <CustomTextbox
            fieldName="border_color"
            value={values.border_color}
            error={errors.border_color}
            label={"Border Color"}
            classes={"col-12"}
            handleBlur={handleBlur}
            inputType={"color"}
            handleChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6" style={{ paddingRight: '10px' }}>
          <CustomTextbox
            fieldName="gradient_color_1"
            value={values.gradient_color_1}
            error={errors.gradient_color_1}
            label={"Gradient Color Start"}
            classes={"col-12"}
            handleBlur={handleBlur}
            inputType={"color"}
            handleChange={handleChange}
          />
        </div>
        <div className="col-6" style={{ paddingLeft: '10px' }}>
          <CustomTextbox
            fieldName="gradient_color_2"
            value={values.gradient_color_2}
            error={errors.gradient_color_2}
            label={"Gradient Color End"}
            classes={"col-12"}
            handleBlur={handleBlur}
            inputType={"color"}
            handleChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12" style={{ paddingLeft: '10px' }}>
          <label className="text-label">Format / Duration</label>
          <input
            onChange={(e) => {
              setFormatDuration(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // prevents form submit if inside a form
                if (formatDuration != "") {
                  setFieldValue("format_duration", [...values.format_duration ?? [], formatDuration]);
                  setFormatDuration("");
                }
                // your logic here
              }
            }}
            value={formatDuration}
            onBlur={handleBlur}
            className="input form-control"
            placeholder="Enter Format / Duration"
            name="format_duration"
          />
          {errors.format_duration && (
            <div
              id="val-format_duration-error"
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors.format_duration}
            </div>
          )}
          <div className="d-flex gap-2 align-items-center mt-3 flex-wrap row-gap-2" style={{
            textTransform: "uppercase"
          }}>
            {values?.format_duration?.map((x, index) => (
              <div onClick={() => removeIndex(index)} style={{ cursor: 'pointer' }}>
                <span className="badge bg-body-secondary fw-semibold" style={{ textTransform: 'none', color: "black", borderRadius: 0, borderRight: '0.1px solid lightgrey' }}>
                  {x}
                </span>
                <span className="badge bg-body-secondary" style={{ textTransform: 'none', color: "black", borderRadius: 0 }}>
                  X
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>



    </Fragment>
  );
};

export default AddUpdateUI;
